/**
 * Appels API directs vers le serveur, sans le relais Vercel.
 *
 * Avant, les appels relatifs « /api/... » passaient par une réécriture Vercel
 * (vercel.json) : le serveur voyait l'adresse IP de Vercel au lieu de celle du
 * visiteur, et tous les utilisateurs partageaient le même compteur des limites
 * de requêtes. En production, ce module réécrit donc chaque URL relative
 * « /api/... » (axios global et fetch) vers le domaine d'API. En développement,
 * les URL restent relatives (proxy de react-scripts, cf. package.json).
 *
 * Importé en premier dans index.js.
 */
import axios from 'axios';

const IS_PROD = process.env.NODE_ENV === 'production';

// « /api/x » correspond à « /api/bourse-idees/x » sur le domaine de Bourse d'Idées
// (même correspondance que l'ancienne réécriture Vercel).
const API_PREFIX = 'https://bourse-idees.innovactive360.cloud/api/bourse-idees/';

/** URL absolue d'un chemin « /api/... » (inchangé en développement ou si déjà absolu). */
export const toApiUrl = (url) => {
  if (!IS_PROD || typeof url !== 'string' || !url.startsWith('/api/')) return url;
  return API_PREFIX + url.slice('/api/'.length);
};

/** Base pour une instance axios dont les chemins sont relatifs à /api. */
export const API_BASE = IS_PROD ? API_PREFIX.replace(/\/$/, '') : '/api';

if (IS_PROD) {
  axios.interceptors.request.use((config) => {
    if (!config.baseURL && typeof config.url === 'string') config.url = toApiUrl(config.url);
    return config;
  });

  if (typeof window !== 'undefined' && typeof window.fetch === 'function') {
    const nativeFetch = window.fetch.bind(window);
    window.fetch = (input, init) => nativeFetch(typeof input === 'string' ? toApiUrl(input) : input, init);
  }
}
